import React, { useState } from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import { useResponsiveView } from '../../hooks/useResponsiveView';

const languages = [
  { code: 'fr', name: 'Français' },
  { code: 'ar', name: 'العربية' },
  { code: 'es', name: 'Español' },
];

const LanguageSelector = ({
  textColor = 'text-gray-700',
  hoverColor = 'hover:text-indigo-600',
  bgColor = 'bg-white',
  iconColor = 'text-gray-700',
  dropdownBgColor = 'bg-white',
  dropdownTextColor = 'text-gray-700',
  dropdownHoverBgColor = 'hover:bg-gray-50',
  dropdownSelectedBgColor = 'bg-indigo-50',
  dropdownSelectedTextColor = 'text-indigo-600'
}) => {
  const { lang, setLanguage } = useLanguage();
  const { isDesktop } = useResponsiveView();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (newLang) => {
    setLanguage(newLang);
    setIsOpen(false);
  };

  const getCurrentLanguage = () => {
    return languages.find(l => l.code === lang)?.name || lang;
  };

  return (
    <div className="relative">
      {isDesktop ? (
        <div className="inline-flex items-center">
          <div className="absolute left-0 z-10">
            <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 ${iconColor}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <select
            value={lang}
            onChange={(e) => setLanguage(e.target.value)}
            className={`appearance-none ${bgColor} pl-8 pr-8 py-1.5 text-sm ${textColor} ${hoverColor} focus:outline-none cursor-pointer min-w-[120px]`}
          >
            {languages.map((lang) => (
              <option key={lang.code} value={lang.code} className={`${bgColor} ${textColor}`}>
                {lang.name}
              </option>
            ))}
          </select>
          <div className="absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none">
            <svg xmlns="http://www.w3.org/2000/svg" className={`h-4 w-4 ${iconColor}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      ) : (
        <div className="relative">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className={`p-2 ${textColor} ${hoverColor} focus:outline-none`}
            title={getCurrentLanguage()}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>
          
          {isOpen && (
            <div className={`absolute right-0 mt-2 w-48 rounded-md shadow-lg ${dropdownBgColor} ring-1 ring-black ring-opacity-5 z-50`}>
              <div className="py-1" role="menu" aria-orientation="vertical">
                {languages.map((language) => (
                  <button
                    key={language.code}
                    onClick={() => handleLanguageChange(language.code)}
                    className={`w-full text-left px-4 py-2 text-sm ${
                      lang === language.code 
                        ? `${dropdownSelectedBgColor} ${dropdownSelectedTextColor}` 
                        : `${dropdownTextColor} ${dropdownHoverBgColor}`
                    }`}
                    role="menuitem"
                  >
                    {language.name}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector; 